// Länderliste (Deutsch). Priorisiert oben, danach alphabetisch.

export const COUNTRIES_TOP = [
  "Deutschland",
  "Österreich",
  "Schweiz",
  "Niederlande",
  "Italien",
];

export const COUNTRIES_ALL_ALPHABETIC = [
  "Afghanistan", "Ägypten", "Albanien", "Algerien", "Andorra", "Angola",
  "Antigua und Barbuda", "Äquatorialguinea", "Argentinien", "Armenien",
  "Aserbaidschan", "Äthiopien", "Australien", "Bahamas", "Bahrain",
  "Bangladesch", "Barbados", "Belarus", "Belgien", "Belize", "Benin",
  "Bhutan", "Bolivien", "Bosnien und Herzegowina", "Botsuana", "Brasilien",
  "Brunei", "Bulgarien", "Burkina Faso", "Burundi", "Chile", "China",
  "Costa Rica", "Dänemark", "Dominica", "Dominikanische Republik", "Dschibuti",
  "Ecuador", "El Salvador", "Elfenbeinküste", "Eritrea", "Estland",
  "Eswatini", "Fidschi", "Finnland", "Frankreich", "Gabun", "Gambia",
  "Georgien", "Ghana", "Grenada", "Griechenland", "Guatemala", "Guinea",
  "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Indien", "Indonesien",
  "Irak", "Iran", "Irland", "Island", "Israel", "Jamaika", "Japan", "Jemen",
  "Jordanien", "Kambodscha", "Kamerun", "Kanada", "Kap Verde", "Kasachstan",
  "Katar", "Kenia", "Kirgisistan", "Kiribati", "Kolumbien", "Komoren",
  "Kongo, Demokratische Republik", "Kongo, Republik", "Kosovo", "Kroatien",
  "Kuba", "Kuwait", "Laos", "Lesotho", "Lettland", "Libanon", "Liberia",
  "Libyen", "Liechtenstein", "Litauen", "Luxemburg", "Madagaskar", "Malawi",
  "Malaysia", "Malediven", "Mali", "Malta", "Marokko", "Marshallinseln",
  "Mauretanien", "Mauritius", "Mexiko", "Mikronesien", "Moldawien", "Monaco",
  "Mongolei", "Montenegro", "Mosambik", "Myanmar", "Namibia", "Nauru",
  "Nepal", "Neuseeland", "Nicaragua", "Niger", "Nigeria", "Nordkorea",
  "Nordmazedonien", "Norwegen", "Oman", "Osttimor", "Pakistan", "Palau",
  "Palästina", "Panama", "Papua-Neuguinea", "Paraguay", "Peru", "Philippinen",
  "Polen", "Portugal", "Ruanda", "Rumänien", "Russland", "Salomonen",
  "Sambia", "Samoa", "San Marino", "São Tomé und Príncipe", "Saudi-Arabien",
  "Schweden", "Senegal", "Serbien", "Seychellen", "Sierra Leone", "Simbabwe",
  "Singapur", "Slowakei", "Slowenien", "Somalia", "Spanien", "Sri Lanka",
  "St. Kitts und Nevis", "St. Lucia", "St. Vincent und die Grenadinen",
  "Südafrika", "Sudan", "Südkorea", "Südsudan", "Suriname", "Syrien",
  "Tadschikistan", "Taiwan", "Tansania", "Thailand", "Togo", "Tonga",
  "Trinidad und Tobago", "Tschad", "Tschechien", "Tunesien", "Türkei",
  "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "Ungarn", "Uruguay",
  "Usbekistan", "Vanuatu", "Vatikanstadt", "Venezuela",
  "Vereinigte Arabische Emirate", "Vereinigte Staaten", "Vereinigtes Königreich",
  "Vietnam", "Zentralafrikanische Republik", "Zypern",
].filter(c => !COUNTRIES_TOP.includes(c))
 .sort((a, b) => a.localeCompare(b, "de"));
